import { Backdrop, Box, Fade, Modal } from "@mui/material";
import modalStyles from "./CustomModal.module.css";

const modalTransitionStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: `clamp(300px, 90vw, 600px)`,
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: "20px",
  paddingBottom: "10px",
  border: "none",
  outline: "none",
  borderRadius: "6px",
  boxSizing: "border-box",
};

function CustomModal(props) {
  return (
    <Modal
      className={modalStyles.modal}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={props.open}>
        <Box sx={{
          ...modalTransitionStyle,
          ...props.style,
        }}>
          <div
            style={{
              boxSizing: "border-box",
              height: "100%",
              width: "100%",
              overflow: "scroll",
            }}
          >
            {props.children}
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}

export default CustomModal;
